/*
 * Registers the non-caching PWA service worker (public/service-worker.js).
 *
 * Only registers in production builds (npm run build / build:test) and only
 * when the browser supports service workers. Skipped under `npm start` so the
 * dev server's hot reload is never shadowed by a worker.
 */

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        console.error('Service worker registration failed:', err);
      });
  });
}
